import { parseDateValue } from '@/utils/formatDate'

export function sortPrensaByDateDesc(prensa) {
  return [...(prensa ?? [])].sort((a, b) => {
    const dateA = parseDateValue(a?.date)
    const dateB = parseDateValue(b?.date)
    return (Number.isNaN(dateB) ? 0 : dateB) - (Number.isNaN(dateA) ? 0 : dateA)
  })
}
